import React from 'react'

interface CheckmarkFilledProps {
  size?: number
  className?: string
}

export const CheckmarkFilled: React.FC<CheckmarkFilledProps> = ({
  size = 24,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="7.25"
        fill="url(#paint0_linear_checkmark)"
        stroke="url(#paint1_linear_checkmark)"
        strokeWidth="1.5"
      />
      <path
        d="M17.6364 8L9.63636 16L6 12.3636"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_checkmark"
          x1="-4.92308"
          y1="17.3333"
          x2="24.032"
          y2="25.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7866FF" />
          <stop offset="1" stopColor="#4732FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_checkmark"
          x1="-4.92308"
          y1="17.3333"
          x2="24.032"
          y2="25.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7866FF" />
          <stop offset="1" stopColor="#4732FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
